import type { SVGProps } from "react";
const SvgGridView = (props: SVGProps<SVGSVGElement>) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g>
      <rect x="0.75" y="14.5833" width="10.6332" height="10.1667" rx="1.25" stroke="currentColor" strokeWidth="1.5" />
      <rect
        x="14.6172"
        y="14.5833"
        width="10.6332"
        height="10.1667"
        rx="1.25"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect x="14.6172" y="1.25" width="10.6332" height="10.1667" rx="1.25" stroke="currentColor" strokeWidth="1.5" />
      <rect x="0.75" y="1.25" width="10.6332" height="10.1667" rx="1.25" stroke="currentColor" strokeWidth="1.5" />
    </g>
  </svg>
);
export default SvgGridView;
